import { render, staticRenderFns } from "./RegisterProduct.vue?vue&type=template&id=c5b833ca&scoped=true&"
import script from "./RegisterProduct.vue?vue&type=script&lang=js&"
export * from "./RegisterProduct.vue?vue&type=script&lang=js&"
import style0 from "./RegisterProduct.vue?vue&type=style&index=0&id=c5b833ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5b833ca",
  null
  
)

export default component.exports